import React, { FC } from "react";
import { LINK_NAV_MENU_ITEMS, SCROLL_NAV_MENU_ITEMS } from "./constants";
import { Link } from "../Link";
import { Button } from "../Button";
import { ButtonVariants } from "../Button/types";
import { scrollTo } from "src/utils/scroll";

export const NavMenu: FC = () => {
  const handleClick = (selector: string) => () => scrollTo(selector);

  return (
    <nav className="flex items-center justify-center gap-4 2xl:gap-6">
      {SCROLL_NAV_MENU_ITEMS.map(({ id, href, label, selector }) => (
        <Link
          key={id}
          href={href}
          onClick={handleClick(selector)}
          isScrollTop={false}
        >
          <Button variant={ButtonVariants.PRIMARY}>{label}</Button>
        </Link>
      ))}

      {LINK_NAV_MENU_ITEMS.map(({ id, href, label }) => (
        <Link key={id} href={href}>
          <Button variant={ButtonVariants.PRIMARY}>{label}</Button>
        </Link>
      ))}
    </nav>
  );
};
